import { api } from "@/lib/api";
import type {
	ExaminerAssignmentResponse,
	ExaminerFeedbackResponse,
	SubmitScoreSheetData
} from "./examiner.schema";

type CreateDissertationData = {
	title: string;
	abstract: string;
	dissertation_file?: File;
	dissertation_docx?: File;
	proposal_file?: File;
	cover_letter_file?: File;
	turnitin_score_file?: File;
};

// API Endpoints
export const createDissertation = async (data: CreateDissertationData) => {
	const formData = new FormData();

	formData.append("title", data.title);
	formData.append("abstract", data.abstract);

	if (data.dissertation_docx) {
		formData.append("dissertation_docx", data.dissertation_docx);
	}
	if (data.dissertation_file) {
		formData.append("dissertation_file", data.dissertation_file);
	}
	// if (data.proposal_docx) {
	// 	formData.append("proposal_docx", data.proposal_docx);
	// }
	if (data.proposal_file) {
		formData.append("proposal_file", data.proposal_file);
	}
	// if (data.cover_letter_docx) {
	// 	formData.append("cover_letter_docx", data.cover_letter_docx);
	// }
	if (data.cover_letter_file) {
		formData.append("cover_letter_file", data.cover_letter_file);
	}
	if (data.turnitin_score_file) {
		formData.append("turnitin_score_file", data.turnitin_score_file);
	}

	const response = await api.post("/dissertations", formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return response.data;
};

export const postComment = async (formData: FormData) => {
	const res = await api.post(`/dissertations/comments`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return res.data;
}

export const getDissertation = async () => {
	const response = await api.get("/dissertations/retrieve");
	return response.data;
};

export const getExaminerAssignment = async (
	dissertationKey: string,
	examinerKey: string,
) => {
	const response = await api.get(`/review-center/${dissertationKey}`, {
		params: {
			examiner_key: examinerKey,
		},
	});

	return response.data as ExaminerAssignmentResponse;
};

export const submitScoreSheet = async (
	dissertationKey: string,
	examinerKey: string,
	data: SubmitScoreSheetData,
) => {
	const response = await api.post(
		`/review-center/${dissertationKey}/score-sheets`,
		data,
		{
			params: {
				examiner_key: examinerKey,
			},
		},
	);

	return response.data;
};

export const getExaminerFeedback = async (
	dissertationKey: string,
	examinerKey: string,
) => {
	const response = await api.get(`/dissertation/${examinerKey}/${dissertationKey}/feedback`);
	return response.data as ExaminerFeedbackResponse;
};

export const postExaminerFeedback = async (
	dissertationKey: string,
	examinerKey: string,
	formData: FormData,
) => {
	const response = await api.post(
		`/dissertation/${examinerKey}/${dissertationKey}/feedback`,
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);

	return response.data;
};
